enum StatusSlaEnum {
  Normal = 'Normal',
  Alerta = 'Alerta',
  Critico = 'Critico',
}

export default StatusSlaEnum
